export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const TOKEN_NAME_IN_STORAGE = "token";

export const AGENT_AUTHOR = [
  "rdh_root_agent",
  "discovery_agent",
  "analysis_agent",
  "remediation_agent",
  "reporting_agent",
  "group_termination_agent",
];
